import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';

import {Cookie} from '../helper/cookie';
import {SettingsService} from '../core/settings.service';
import * as fromAuth from './store/auth.reducers';
import * as fromApp from './../store/app.reducers';

@Injectable()
export class AuthService {

  cookies: Cookie;

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private store: Store<fromApp.AppState>
  ) {
    this.cookies = new Cookie();
  }

  login(email, password) {
    const headers = new HttpHeaders()
      .set(
        'Authorization',
        'Basic ' + btoa(email + ':' + password)
      )
      .set(
        'Content-Type',
        'application/json'
      );
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'tokens',
      {},
      {
        headers: headers
      }
    );

  }

  loginByUid(userUid: string) {
    const headers = new HttpHeaders()
      .set(
        'Content-Type',
        'application/json'
      );
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'token/by/uid',
      {
        user_uid: userUid
      },
      {
        headers: headers
      }
    );

  }

  loginByFacebook(accessToken: string, params: any) {
    const headers = new HttpHeaders()
      .set(
        'Content-Type',
        'application/json'
      );

    const body = {
      access_token: accessToken
    };

    if (params.uid !== undefined) {
      body['uid'] = params.uid;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'users/facebook',
      body,
      {
        headers: headers
      }
    );

  }

  loginByGoogle(accessToken: string, params: any) {
    const headers = new HttpHeaders()
      .set(
        'Content-Type',
        'application/json'
      );

    const body = {
      access_token: accessToken
    };

    if (params.uid !== undefined) {
      body['uid'] = params.uid;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'users/google',
      body,
      {
        headers: headers
      }
    );

  }

  isAuthenticated(): Observable<boolean> {
    return this.store.select('auth')
      .pipe(
        take(1),
        map(
          (state: fromAuth.State) => {
            if (state.token != null) {
              const actualDate = +new Date().getTime() / 1000;
              if (actualDate < state.exp) {
                return true;
              }
            }
            return false;
          }
        )
      );
  }

  isAnonymous(): Observable<boolean> {
    return this.store.select('auth')
      .pipe(
        take(1),
        map(
          (state: fromAuth.State) => {
            if (state.token != null) {
              const actualDate = +new Date().getTime() / 1000;
              if (actualDate < state.exp) {
                return false;
              }
            }
            return true;
          }
        )
      );
  }
}
